module.exports = __webpack_public_path__ + "img/mongodb-svgrepo-com.60d5223a.svg";